import { i18n } from '@/i18n/i18n.config'
import TruckIcon from '@/components/icons/TruckIcon.vue'
import SemiTrailerIcon from '@/components/icons/SemiTrailerIcon.vue'
import TransporterIcon from '@/components/icons/TransporterIcon.vue'
import { VehicleCategory } from '@/types/enums'

const { t } = i18n.global

export const sortedCategories = [
  {
    slug: VehicleCategory.transporter,
    icon: null,
    img: 'transporter.png',
    title: t('vehicles.category.short.' + VehicleCategory.transporter),
  },
  {
    slug: VehicleCategory.lkw,
    icon: TransporterIcon,
    img: 'lkw.png',
    title: t('vehicles.category.short.' + VehicleCategory.lkw),
  },
  {
    slug: VehicleCategory.semi_trailer,
    icon: SemiTrailerIcon,
    img: 'semi_trailer.png',
    title: t('vehicles.category.' + VehicleCategory.semi_trailer),
  },
  {
    slug: VehicleCategory.truck,
    icon: TruckIcon,
    img: 'truck.png',
    title: t('vehicles.category.' + VehicleCategory.truck),
  },
  {
    slug: VehicleCategory.body,
    icon: null,
    img: null,
    title: t('vehicles.category.' + VehicleCategory.body),
  },
  {
    slug: VehicleCategory.trailer,
    icon: null,
    img: null,
    title: t('vehicles.category.' + VehicleCategory.trailer),
  },
  {
    slug: VehicleCategory.container,
    icon: null,
    img: null,
    title: t('vehicles.category.' + VehicleCategory.container),
  },
]
